module.exports = __webpack_public_path__ + "static/monei_pay_2_en-24dac79227cd01f573184977470286c3.png";